export default "__VITE_ASSET__CFmHhuW5__"